<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.jornadaSituacao"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleEdit(item.id)"
                authorize="create-ambulatorio-jornada-situacao"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="handleDestroy(item)"
                authorize="destroy-ambulatorio-jornada-situacao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            jornadaSituacao: this.getConectaSusRepository('ambulatorio.jornadaSituacao'),
        }
    },
    data: () => ({
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                name: 'situacao.nome',
                searchable: true,
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
                name: 'actions',
            },
        ],
    }),
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'ambulatorio-jornada-situacao-edit', params: { id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.jornadaSituacao.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a situação de jornada?', destroy)
        },
    },
    mixins: [error, repository],
}
</script>